// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getConfsRegistro as listConfRegAPI,
    getConfRegistro as getConfRegAPI,
    addConfRegistro as addConfRegAPI,
    updateConfRegistro as updateConfRegAPI,
    deleteConfRegistro as deleteConfRegAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { confRegApiResponseError, confRegApiResponseSuccess } from './actions';
import { ConfRegActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getConfReg({ payload: { id } }) {
    try {
        const response = yield call(getConfRegAPI, id );
        const confRegItem = response.data.data;
        yield put(confRegApiResponseSuccess(ConfRegActionTypes.GET_CONF_REG, confRegItem));
    } catch (error) {
        yield put(confRegApiResponseError(ConfRegActionTypes.GET_CONF_REG, error));
    }
}

function* addConfReg({payload:confReg}){
    try{
        const response = yield call(addConfRegAPI,{...confReg})
        const confRegItem = response.data
        yield put(confRegApiResponseSuccess(ConfRegActionTypes.ADD_CONF_REG,confRegItem))
    } catch(error){
        yield put(confRegApiResponseError(ConfRegActionTypes.ADD_CONF_REG,error))
    }
}

function* updateConfReg({payload:confReg}){
    try{
        const response = yield call(updateConfRegAPI,{...confReg})
        const confRegItem = response.data.data
        yield put(confRegApiResponseSuccess(ConfRegActionTypes.UPDATE_CONF_REG,confRegItem))
    }catch(error){
        yield put(confRegApiResponseError(ConfRegActionTypes.UPDATE_CONF_REG,error))
    }
}
function* deleteConfReg({payload:{id}}){
    try{
        const response = yield call(deleteConfRegAPI,id)
        const confRegItem = response.data.id
        yield put(confRegApiResponseSuccess(ConfRegActionTypes.DELETE_CONF_REG,confRegItem))
    }catch(error){
        yield put(confRegApiResponseError(ConfRegActionTypes.DELETE_CONF_REG,error))
    }
}

/**
 * List contactos
 */
function* listConfReg({payload:params}) {
    try {
        const response = yield call(listConfRegAPI, { ...params });
        const listaConfReg = response.data.data;
        yield put(confRegApiResponseSuccess(ConfRegActionTypes.LIST_CONF_REG, listaConfReg));
    } catch (error) {
        yield put(confRegApiResponseError(ConfRegActionTypes.LIST_CONF_REG, error));
    }
}


export function* watchGetConfReg(): any {
    yield takeEvery(ConfRegActionTypes.GET_CONF_REG, getConfReg);
}

export function* watchListConfReg(): any {
    yield takeEvery(ConfRegActionTypes.LIST_CONF_REG, listConfReg);
}

export function* watchAddConfReg():any{
    yield takeEvery(ConfRegActionTypes.ADD_CONF_REG,addConfReg)
}
export function* watchUpdateConfReg():any{
    yield takeEvery(ConfRegActionTypes.UPDATE_CONF_REG,updateConfReg)
}
export function* watchDeleteConfReg():any{
    yield takeEvery(ConfRegActionTypes.DELETE_CONF_REG,deleteConfReg)
}


function* confRegSaga(): any {
    yield all([
        fork(watchGetConfReg),
        fork(watchListConfReg),
        fork(watchAddConfReg),
        fork(watchUpdateConfReg),
        fork(watchDeleteConfReg),
    ]);
}

export default confRegSaga;
